module.exports = __webpack_public_path__ + "static/media/hStream_Logo_blue.301f9836.png";